export default __webpack_public_path__ + "static/media/all.96bc7404.svg";